import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import cn from "classnames";
import styled from "styled-components";
import bgNotice from "src/assets/images/bgNotice.svg";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual } from "react-redux";
import AlarmButton from "src/components/common/AlarmButton";
import { useSelectUserQuery } from "src/api/userAPI";

function notice() {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const [hasAlarm, setHasAlarm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/home");
  }, [])

  // 임시 API 호출
  const userApiTemp = useSelectUserQuery(userInfo.user_id);

  return (
    <>
      <header className={cn({ hasAlarm: hasAlarm })}>
        <div>
          <Button variant="text" className="btn-back no-ico">
            공지
          </Button>
        </div>
        <div className="btn-box">
          <AlarmButton />
          <IconButton btnName="마이페이지" className="user" onClick={() => navigate("/profile/" + userInfo.user_id)}>
            <SVG name="userBlack" />
          </IconButton>
        </div>
      </header>

      <Body isTabbar={true}>
        <ComingSoonSet>
          <div className="flex-item">
            <SVG name="comingSoon" width={230} height={230} viewBox="0 0 230 230" />
            <div>
              <p>
                SMS에 올라온 공지를 확인하고
                <br />
                네이버 밴드에 사진 올리던 업무를
                <br />
                대체할 수 있는 기능이 추가될 예정이에요!
              </p>
              <p>열심히 만들고 있으니 조금만 기다려주세요:)</p>
            </div>
          </div>
        </ComingSoonSet>
      </Body>
    </>
  );
}

const ComingSoonSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "flex-start", "center")}
  height: 100%;
  padding-top: 80px;
  .flex-item {
    position: relative;
    width: 100%;
    padding: 185px 15px 0;
    text-align: center;
    > svg {
      position: absolute;
      top: 0;
      left: 50%;
      display: inline-block;
      width: 230px;
      height: 230px;
      margin-left: -115px;
    }
    > div {
      padding: 60px 0 25px;
      border: 1px solid ${({ theme }) => theme.color.main};
      border-left: none;
      border-right: none;
      background: url(${bgNotice}) no-repeat 0 40px;
      color: #4c5b70;
      font-size: 15px;
      line-height: 22px;
      > p:last-child {
        margin-top: 30px;
      }
    }
  }
`;

export default notice;
